import { useState, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { socket } from 'api';
import { dropCall } from 'store/actions/calls';
import { removeWidget } from 'store/actions/widgets';
import { Timer } from './timer';
import { SourceIcon } from './source-icon';
import { Content, BottomPanel, CallStatus, Dot, DropCall, TopPanel } from './active-call.styled';

export const ActiveCall = ({ className }) => {
  const dispatch = useDispatch();
  const calls = useSelector((store) => store.calls.calls, shallowEqual);
  const [activeCall, setActiveCall] = useState([]);
  const [end, setEnd] = useState(false);
  const [cntPayment, setCntPayment] = useState(0);
  const [cntRack, setCntRack] = useState(0);

  useEffect(() => {
    findActiveCall();
    return () => {
      window.addEventListener('beforeunload', cancelAllCalls);
      window.onclose = cancelAllCalls;
    };
  }, []);

  /**
   * find active call
   */
  const findActiveCall = () => {
    const active = [];
    const activeCalls = window.getActiveCalls();
    let cntPayment = 0;
    let cntRack = 0;
    for (let key in activeCalls) {
      const item = calls[key];
      if (item) {
        active.push(item);
        const node = getNodeName(item.source_inner_id);
        if (node.payment) {
          cntPayment++;
        } else {
          cntRack++;
        }
      }
    }
    setActiveCall(active);
    setCntPayment(cntPayment);
    setCntRack(cntRack);
  };

  const getNodeName = (id) => {
    const types = {
      cashbox: 'Касса',
      single_rack: 'Стойка',
      payment_terminal: 'АПП',
    };
    if (!window.config.nodes[id]) {
      return { title: '' + id, payment: false };
    }
    const item = window.config.nodes[id];
    let out = types[item.type] ? types[item.type] + ' ' : '';
    out += item.caption;
    return { title: out, payment: item.type === 'payment_terminal' };
  };

  const getSourceNumber = () => {
    let paymentTerminalIds = [];
    let rackIds = [];
    activeCall.forEach((item) => {
      const node = getNodeName(item.source_inner_id);
      if (node.payment) {
        paymentTerminalIds.push(node.title);
      } else {
        rackIds.push(node.title);
      }
    });
    if (!paymentTerminalIds.length && !rackIds.length) {
      return null;
    }

    return (
      <>
        {paymentTerminalIds.length ? (
          <p>
            <Dot color={'#4b7153'} />
            {paymentTerminalIds.join(', ')}
          </p>
        ) : null}
        {rackIds.length ? (
          <p>
            <Dot color={'#7e7343'} />
            {rackIds.join(', ')}
          </p>
        ) : null}
      </>
    );
  };

  /**
   * cancel all calls
   */
  const cancelAllCalls = () => {
    setEnd(true);
    // cancel in socket
    activeCall.forEach((item) => {
      socket.call('call_end', item);
    });
    // cancel in front
    window.setTimeout(() => {
      activeCall.forEach((item) => {
        dispatch(dropCall(item.source_inner_id));
      });
      dispatch(removeWidget('activeCall'));
    }, 1000);
  };

  const sourceEl = getSourceNumber();
  return (
    <Content className={className}>
      <TopPanel>
        <SourceIcon cntPayment={cntPayment} cntRack={cntRack} />
        <CallStatus>{end ? 'Конец разговора' : <Timer />}</CallStatus>
        <DropCall onClick={cancelAllCalls} type="button"></DropCall>
      </TopPanel>
      {sourceEl !== null && <BottomPanel>{sourceEl}</BottomPanel>}
    </Content>
  );
};
